import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import customTheme from "config/theme";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "block"
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      outline: "none",
      boxShadow: theme.shadows[5],
      padding: "16px 12px 24px",
      borderRadius: 5,
      maxHeight: "70vh",
      overflowY: "auto",
      overflowX: "hidden",
      maxWidth: 380,
      [theme.breakpoints.down("xs")]: {
        maxWidth: "90vw !important"
      },
      [theme.breakpoints.down("md")]: {
        maxWidth: "50vw"
      },
      margin: "auto",
      marginTop: "10vh",
      "&::-webkit-scrollbar": {
        width: "8px"
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent"
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#ccc",
        borderRadius: "4px"
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#aaa"
      }
    },
    title: {
      fontSize: 16,
      fontWeight: 600,
      borderBottom: "1px solid #dddddd",
      paddingBottom: 10,
      marginBottom: 0,
      textAlign: "center"
    },
    root: {
      "& .MuiTextField-root": {
        margin: theme.spacing(1)
      }
    },
    label: {
      fontSize: 12,
      color: "#adadad",
      textTransform: "uppercase",
      marginTop: 20,
      marginBottom: 3
    },
    radioLabel: {
      color: "#888888",
      marginBottom: -8
    },
    radio: {
      color: (customTheme as any).bgButton,
      "&.Mui-checked": {
        color: (customTheme as any).bgButton,
        fontSize: 12
      }
    }
  })
);

export default useStyles;
